import { queries } from '../lib/supabase/queries';

export const testimonialsService = {
  async getAll() {
    return queries.testimonials.getAll();
  },

  async getPublished() {
    return queries.testimonials.getPublished();
  },

  async create(item) {
    return queries.testimonials.create(item);
  },

  async update(id, updates) {
    return queries.testimonials.update(id, updates);
  },

  async delete(id, storagePath = '') {
    return queries.testimonials.delete(id, storagePath);
  },
};

export default testimonialsService;
